import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { waLink } from "@/lib/content";
import { Logo } from "./Header";

const COLS = [
  ["Help", [["Contact Us", "contact"], ["Size Guide", "size-guide"], ["Shipping Information", "shipping"], ["Returns and Exchange", "returns"], ["Track Order", "track-order"], ["FAQs", "faqs"]]],
  ["Kurtaani", [["Navratri Couple Edit", "/navratri-couple-edit"], ["About Kurtaani", "about"], ["Privacy Policy", "privacy"], ["Terms and Conditions", "terms"], ["Refund Policy", "refund"]]],
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list! Look out for styling notes soon.");
      setEmail("");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <footer data-testid="site-footer" className="relative mt-10 bg-[#1B4332] text-[#EAE0D5]">
      <div className="kt-container grid gap-12 py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo light />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#EAE0D5]/80">Kurtaani designs breathable, beautifully finished ethnic wear for the modern Indian woman – from Monday meetings to midnight sangeets.</p>
          <div className="mt-6 flex gap-3">
            {[[Instagram, "https://instagram.com/kurtaani", "instagram"], [Facebook, "https://facebook.com/kurtaani", "facebook"], [MessageCircle, waLink("Hi Kurtaani!"), "whatsapp"]].map(([I, h, k]) => (
              <a key={k} href={h} target="_blank" rel="noreferrer" data-testid={`footer-social-${k}`} aria-label={k} className="rounded-full border border-[#EAE0D5]/30 p-2.5 transition-colors hover:bg-[#FAF7F2] hover:text-[#1B4332]"><I className="h-4 w-4" /></a>
            ))}
          </div>
        </div>
        {COLS.map(([t, links]) => (
          <div key={t} className="lg:col-span-2">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D99B8E]">{t}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {links.map(([l, p]) => (
                <li key={p}><Link to={p.startsWith("/") ? p : `/pages/${p}`} data-testid={`footer-link-${p.replace("/", "")}`} className="text-[#EAE0D5]/85 transition-colors hover:text-white">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-4">
          <p className="font-serif-display text-3xl text-[#FAF7F2]">Join the Kurtaani Circle</p>
          <p className="mt-2 text-sm text-[#EAE0D5]/80">Get styling tips, new arrivals, and exclusive offers.</p>
          <form onSubmit={submit} className="mt-5 flex rounded-full bg-[#FAF7F2] p-1.5">
            <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" className="flex-1 bg-transparent px-4 text-sm text-[#1C1917] outline-none" />
            <button data-testid="newsletter-submit-button" className="rounded-full bg-[#701A24] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#56131B]">Subscribe</button>
          </form>
          <p className="mt-6 text-xs text-[#EAE0D5]/60">We accept all UPI apps · Google Pay · PhonePe · Paytm · BHIM</p>
        </div>
      </div>
      <div className="border-t border-[#EAE0D5]/15 py-5 text-center text-xs text-[#EAE0D5]/60">© {new Date().getFullYear()} Kurtaani. Designed with love in India.</div>
    </footer>
  );
}
